document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('guide-bot-modal');
  if (!modal) return;

  const openButtons = document.querySelectorAll('[data-branch-guide-open]');
  const closeButtons = modal.querySelectorAll('[data-guide-bot-close]');
  const stepContainer = document.getElementById('guide-bot-step-container');

  const backBtnArea = document.getElementById('back-btn-area');
  const backToPrevButton = document.getElementById('back-to-prev');
  const backToFirstButton = document.getElementById('back-to-first');


  //----------------------------------------------------------------------
  //----------------------------------------------------------------------
  
  // 分岐定義（ここだけ更新すればOK）
  // nextオブジェクト or 遷移先のURLパスで各質問 + 回答 を定義していくだけ  
  const TREE = {
    start: {
      question: 'いらっしゃいませ、商品をどのようにお探ししましょうか？',
      options: [
        { label: '用途から探したい', next: 'usage' },
        { label: 'ブランドから探したい', next: 'brand' }
      ]
    },

// ---------用途から探す
    usage: {
      question: 'どの商品をお探しですか？',
      options: [
        { label: '水着(大人)', next: 'swimwear' },
        { label: 'ジュニア水着', next: 'kidsSwimwear' },
        { label: 'ゴーグル', next: 'goggles' },
        { label: 'スイムキャップ', next: 'swimCap' }
      ]
    },

    // -----水着(大人)
    swimwear: {
      question: 'どちらをお探しですか？',
      options: [
        { label: 'メンズ', next: 'swimwear_mens' },
        { label: 'レディース', next: 'swimwear_ladys' }
      ]
    },

    // 水着(大人)メンズ
        swimwear_mens: {
        question: '用途をお選びください',
      options: [
        { label: '競泳水着', next: 'swimwear_mens_competitive' },
        { label: 'フィットネス水着', url: '/collections/mens-fitness-swimwear' }
      ]
    },
        swimwear_mens_competitive: {
        question: '用途をお選びください',
      options: [
        { label: 'レーシング水着', url: '/collections/mens-racing-swimwear' },
        { label: '練習用水着', url: '/collections/toreningu_mensmenzu' }
      ]
    },

    // 水着(大人)レディース
        swimwear_ladys: {
        question: '用途をお選びください',
      options: [
        { label: '競泳水着', next: 'swimwear_ladys_competitive' },
        { label: 'フィットネス水着', url: '/collections/huitutonesu_womensuimenzu' }
      ]
    },
        swimwear_ladys_competitive: {
        question: '用途をお選びください',
      options: [
        { label: 'レーシング水着', url: '/collections/womens-racing-swimwear' },
        { label: '練習用水着', url: '/collections/womens-training-swimwear' }
      ]
    },
    
    
    // -----ジュニア水着
    kidsSwimwear: {
        question: 'どちらをお探しですか？',
      options: [
        { label: 'ボーイズ', next: 'kidsSwimwear_boys' },
        { label: 'ガールズ', next: 'kidsSwimwear_girls' }
      ]
    },

    // ジュニア水着ボーイズ
        kidsSwimwear_boys: {
        question: '用途をお選びください',
      options: [
        { label: 'ジュニア競泳', next: 'kidsSwimwear_boys_competitive' },
        { label: 'スクール水着', url: '/collections/junior-training-swimwear' }
      ]
    },
        kidsSwimwear_boys_competitive: {
        question: '用途をお選びください',
      options: [
        { label: 'レーシング水着', url: '/collections/junior-racing-swimwear' },
        { label: '練習用水着', url: '/collections/toreningu_boys-boizu' }
      ]
    },

    // ジュニア水着ガールズ
        kidsSwimwear_girls: {
        question: '用途をお選びください',
      options: [
        { label: 'ジュニア競泳', next: 'kidsSwimwear_girls_competitive' },
        { label: 'スクール水着', url: '/collections/garuzusukurushui-zhao' }
      ]
    },
        kidsSwimwear_girls_competitive: {
        question: '用途をお選びください',
      options: [
        { label: 'レーシング水着', url: '/collections/garuzuresingu' },
        { label: '練習用水着', url: '/collections/toreningu_juniorziyunia' }
      ]
    },


    // -----ゴーグル
    goggles: {
      question: 'どの商品をお探しですか？',
      options: [
        { label: 'WA/FINA承認つき', url: '/collections/%E3%82%B4%E3%83%BC%E3%82%B0%E3%83%AB-%E3%83%8E%E3%83%B3%E3%82%AF%E3%83%83%E3%82%B7%E3%83%A7%E3%83%B3-%E3%82%B3%E3%83%94%E3%83%BC' },
        { label: '練習用・スクール・フィットネス', url: '/collections/gogglesgoguru/%E3%83%95%E3%82%A3%E3%83%83%E3%83%88%E3%83%8D%E3%82%B9' },
        { label: 'ゴーグルパーツ', url: '/collections/%E3%82%B4%E3%83%BC%E3%82%B0%E3%83%AB-wa%E6%89%BF%E8%AA%8D-%E3%82%B3%E3%83%94%E3%83%BC/%E3%82%B4%E3%83%BC%E3%82%B0%E3%83%AB%E3%83%91%E3%83%BC%E3%83%84' },
      ]
    },

    // -----スイムキャップ
    swimCap: {
      question: 'どの商品をお探しですか？',
      options: [
        { label: 'シリコン', url: '/collections/capskiyatupu/%E3%82%B7%E3%83%AA%E3%82%B3%E3%83%BC%E3%83%B3' },
        { label: 'メッシュ', url: '/collections/capskiyatupu/%E3%83%A1%E3%83%83%E3%82%B7%E3%83%A5' },
        { label: 'その他', url: '/collections/capskiyatupu' }
      ]
    },

// ---------ブランドから探す
    brand: {
      question: 'お探しのブランドを選んでください',
      options: [
        { label: 'arena', url: '/collections/arenaarina' },
        { label: 'mizuno', url: '/collections/mizuno' },
        { label: 'speedo', url: '/collections/speedosupido' },
        { label: 'SWANS', url: '/collections/swansスワンズ' },
        { label: 'VIEW', url: '/collections/viewビュー' },
        { label: 'その他ブランド', url: '/collections?type=brands' }
      ]
    }

  };

  //----------------------------------------------------------------------
  //----------------------------------------------------------------------



  let currentStep = 'start';
  let historyStack = [];
  let lastFocusedElement = null;

  // 起動ボタンを隠す
    function setOpenButtonsHidden(hidden) {
    openButtons.forEach(function (button) {
      button.classList.toggle('is-hidden', hidden);
      button.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });
  }

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    setOpenButtonsHidden(true);

    historyStack = [];
    renderStep('start');

    const focusTarget = modal.querySelector('.guide-bot-modal__close');
    if (focusTarget) focusTarget.focus();
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    setOpenButtonsHidden(false);

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function renderStep(stepKey) {
    const step = TREE[stepKey];
    if (!step) return;

    currentStep = stepKey;

    stepContainer.innerHTML = `
      <div class="guide-bot-step">
        <p class="guide-bot-step__question">${escapeHtml(step.question)}</p>
        <div class="guide-bot-step__options">
          ${step.options.map(function (option, index) {
            return `
              <button
                type="button"
                class="guide-bot-step__option"
                data-guide-bot-option-index="${index}"
              >
                ${escapeHtml(option.label)}
              </button>
            `;
          }).join('')}
        </div>
      </div>
    `;

    updateNavButtons();

    const optionButtons = stepContainer.querySelectorAll('[data-guide-bot-option-index]');
    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const index = Number(button.dataset.guideBotOptionIndex);
        const selected = step.options[index];
        if (!selected) return;

        if (selected.next) {
          historyStack.push(currentStep);
          renderStep(selected.next);
          return;
        }

        if (selected.url) {
          window.location.href = selected.url;
          closeModal();
        }
      });
    });
  }

  function updateNavButtons() {
    const isAtStart = currentStep === 'start';
    backBtnArea.hidden = isAtStart;

    if (isAtStart) return;

    backToPrevButton.disabled = historyStack.length === 0;
    backToPrevButton.style.opacity = historyStack.length === 0 ? '0.5' : '1';
    backToPrevButton.style.pointerEvents = historyStack.length === 0 ? 'none' : 'auto';
  }

  function goBackToPrev() {
    const prev = historyStack.pop();
    if (!prev) return;
    renderStep(prev);
  }

  function goBackToFirst() {
    historyStack = [];
    renderStep('start');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  if (backToPrevButton) {
    backToPrevButton.addEventListener('click', goBackToPrev);
  }

  if (backToFirstButton) {
    backToFirstButton.addEventListener('click', goBackToFirst);
  }

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
    }
  });
});